module.exports = __webpack_public_path__ + "media/img/uploads/program-office-nist-6781dacb38fb6823a6d3ce30acc12470.jpg";